var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54557 0.36377C2.77403 0.36377 2.03409 0.670262 1.48853 1.21582C0.942967 1.76138 0.636475 2.50132 0.636475 3.27286V3.56522L9.36375 8.26486L18.091 3.56668V3.27286C18.091 2.50132 17.7845 1.76138 17.239 1.21582C16.6934 0.670262 15.9535 0.36377 15.1819 0.36377H3.54557ZM18.091 5.21759L9.70848 9.73104C9.60252 9.78808 9.48408 9.81793 9.36375 9.81793C9.24342 9.81793 9.12497 9.78808 9.01902 9.73104L0.636475 5.21759V12.0001C0.636475 12.7717 0.942967 13.5116 1.48853 14.0572C2.03409 14.6027 2.77403 14.9092 3.54557 14.9092H15.1819C15.9535 14.9092 16.6934 14.6027 17.239 14.0572C17.7845 13.5116 18.091 12.7717 18.091 12.0001V5.21759Z",
    fill: "#1773BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.c2b789d5611065bf29f2c2c94ecb53fb.svg";
export { ForwardRef as ReactComponent };